import { categories } from "@/mocks/categories";

export default function FullCategoryCards() {
  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium uppercase tracking-wider mb-4">
            Todas as Categorias
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Explore Nossas Planilhas
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Escolha uma categoria e acesse produtos organizados com os melhores preços da China
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className="aspect-[1/1]">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.namePt} - CSSBuy Spreadsheet`}
                  title={`${cat.namePt} - planilha CSSBuy`}
                  className="w-full h-full object-cover object-top transition-transform duration-400 group-hover:scale-105"
                />
              </div>
              <div className="p-3">
                <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">{cat.namePt}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}